import { render, staticRenderFns } from "./exportButton.vue?vue&type=template&id=0c4b7f8e&scoped=true"
import script from "./exportButton.vue?vue&type=script&lang=js"
export * from "./exportButton.vue?vue&type=script&lang=js"
import style0 from "./exportButton.vue?vue&type=style&index=0&id=0c4b7f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b7f8e",
  null
  
)

export default component.exports